import axios from "axios";

// ✅ Sirf .env se URL lega, koi fallback nahi
const API_BASE_URL = process.env.REACT_APP_API_URL;

/* ================= GET CART ================= */
export const getCartByUserId = async (userId) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}MasterAPI/GetCartByUserId?userId=${userId}`
    );

    const raw = res?.data?.data?.[0];

    if (!raw || !raw.itemsJson) {
      return { cartId: 0, items: [] };
    }

    let parsedItems = [];

    try {
      parsedItems =
        typeof raw.itemsJson === "string"
          ? JSON.parse(raw.itemsJson)
          : raw.itemsJson || [];
    } catch (e) {
      console.error("JSON PARSE ERROR:", e);
      parsedItems = [];
    }

    const items = parsedItems.map((i) => ({
      productId: Number(i.ProductId),
      categoryId: Number(i.CategoryId),
      name: i.ItemName || "",
      quantity: Number(i.TotalQuantity || 0),
      price: Number(i.Price || 0),
      totalPrice: Number(i.TotalPrice || 0),
      storeId: Number(i.StoreId || 0),
      image: i.Image || "",
    }));

    return {
      cartId: raw.cartId,
      items,
    };
  } catch (err) {
    console.error("GET CART ERROR:", err);
    return { cartId: 0, items: [] };
  }
};

/* ================= ADD / REMOVE CART ================= */
export const updateCartOnServer = async (payload) => {
  try {
    const res = await axios.post(
      `${API_BASE_URL}MasterAPI/AddToCart`,
      {
        userId: payload.userId,
        productId: Number(payload.productId),
        categoryId: Number(payload.categoryId),
        totalQuantity: Number(payload.totalQuantity),
        price: Number(payload.price || 0),
        discount: Number(payload.discount || 0),
        coupon: payload.coupon || "",
      }
    );

    return res.data;
  } catch (err) {
    console.error("UPDATE CART ERROR:", err);
    return { succeeded: false };
  }
};

/* ================= DELETE CART ================= */
export const deleteCartOnServer = async (cartId) => {
  try {
    console.log("📡 DELETE API HIT");

    const res = await axios.post(
      `${API_BASE_URL}MasterAPI/DeleteCart`,
      {
        cardId: Number(cartId),
      }
    );

    console.log("🟢 DELETE RESPONSE:", res.data);

    return res.data;
  } catch (err) {
    console.error("❌ DELETE API ERROR:", err);
    return { succeeded: false };
  }
};